import React from 'react'

// Style sheet
import '../scss/oceanContent.scss';

// Page components
import TopNavbar from "../../components/pagecomponents/ts/topNavbar";
import Footer from "../../components/pagecomponents/ts/Footer";
import PageBanner from '../../components/pagecomponents/ts/pageBanner';
import SouthChinaSeaForcast from "../../components/oceancomponets/ts/southChinaSeaForcast";
import SeaTemperature from "../../components/oceancomponets/ts/seaTemperature";

export default function OceanContent() {
  return (
    <div>
        <div>
          <TopNavbar />
        </div>

        <div>
          <PageBanner 
            title={"海洋氣象"} 
            description={"為你帶來最優質的海洋氣象資料"} 
            icon={"FaWater"} 
            id={"mainPageBanner"}
          />
        </div>

        <div>
            <SouthChinaSeaForcast />
        </div>

        <div>
            <SeaTemperature />
        </div>

        <div>
          <Footer />
        </div>
    </div>
  )
}
